import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import {
  RequestInnerRequestInterface,
  RequestInnerResponseInterface,
  RequestInterface,
} from '@interface/logs/logs.interface';

export const requestLogsColumns: ColumnsType<RequestInterface> = [
  {
    title: 'Time',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (date) => dayjs(date).format('DD/MM/YYYY HH:mm'),
  },
  // {
  //   title: 'Request ID',
  //   dataIndex: 'requestId',
  //   key: 'requestId',
  // },
  {
    title: 'Service',
    dataIndex: 'serviceId',
    key: 'serviceId',
  },
  {
    title: 'URL',
    dataIndex: 'request',
    key: 'request',
    render: (data: RequestInnerRequestInterface) => data.url,
  },
  {
    title: 'Method',
    dataIndex: 'request',
    key: 'request',
    render: (data) => data?.method.toUpperCase(),
  },
  {
    title: 'Latency',
    dataIndex: 'response',
    key: 'response',
    render: (data: RequestInnerResponseInterface) => `${data?.latencyMs.toFixed(2) ?? 0}ms`,
  },
];
